/*
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
 * software and associated documentation files (the "Software"), to deal in the Software
 * without restriction, including without limitation the rights to use, copy, modify,
 * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, PLATFORM_ID, NgZone, LOCALE_ID } from '@angular/core';
import { LocationStrategy, HashLocationStrategy, PathLocationStrategy, CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { OidcConfigService, AuthModule } from 'angular-auth-oidc-client';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

// RECOMMENDED
import { CarouselModule } from 'ngx-bootstrap/carousel';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './default-layout';


import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LogoffComponent } from './views/logoff/logoff.component';

const APP_CONTAINERS = [
  DefaultLayoutComponent,

];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { AlertModule } from 'ngx-bootstrap/alert';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts';
import { HttpClient } from '@angular/common/http';
import { configureAuth } from './views/auth/auth-config';
import { UnauthorizedComponent } from './views/error/unauthorized.component';
import { httpInterceptorProviders } from './interceptors';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthConfigurationService } from './views/auth/auth-configuration.service';
import {MatSelectModule} from '@angular/material/select';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database'
import { environment } from '../environments/environment';
import {CoreModule} from './core/core.module';
import {MaterialExampleModule} from '../material.module';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { ActivationPageComponent } from './views/auth/activation-page/activation-page.component';
import { ProfileComponent } from './views/auth/profile/profile.component';
import { ResetemailComponent } from './views/auth/resetemail/resetemail.component';
import { SubscriptionPlansComponent } from './payment/subscription-plans/subscription-plans.component';
import { PaymentformComponent } from './payment/paymentform/paymentform.component';
import { FuseSharedModule } from '../@fuse/shared.module';
import { Routes } from '@angular/router';
import { FuseProgressBarModule } from "../@fuse/components/progress-bar/progress-bar.module";
import { FuseSidebarModule } from "../@fuse/components/sidebar/sidebar.module";
import { FuseThemeOptionsModule } from "../@fuse/components/theme-options/theme-options.module";
import { PowerBIEmbedModule } from 'powerbi-client-angular';
import { DashboardClientsComponent } from './admin/dashboard-clients/dashboard-clients.component';
import { CreateProfileComponent } from './admin/CreateProfile/CreateProfile.component';
import { profileService } from './admin/CreateProfile/profile.service';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { InvitationDialogComponent } from './invitation-dialog/invitation-dialog.component';












@NgModule({
    declarations: [
        ...APP_CONTAINERS,
        AppComponent,
        LogoffComponent,
        P404Component,
        P500Component,
        UnauthorizedComponent,
        LandingPageComponent,
        ActivationPageComponent,
        ResetemailComponent,
        SubscriptionPlansComponent,
        PaymentformComponent,
        CreateProfileComponent,
        InvitationDialogComponent
      
     
    

    ],
    providers: [
      profileService,

        HttpClient,
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy,
          
        },
        OidcConfigService,
        httpInterceptorProviders,
        AuthConfigurationService,
    ],
    bootstrap: [AppComponent],
    imports: [
        // AngularFireModule.initializeApp(environment.firebaseConfig),
        // AngularFireAuthModule,
        MaterialExampleModule,
        AngularFireDatabaseModule,
        CoreModule,
        CommonModule,
        MatSelectModule,
        AlertModule.forRoot(),
        AppAsideModule,
        AppBreadcrumbModule.forRoot(),
        AppFooterModule,
        AppHeaderModule,
        AppRoutingModule,
        AppSidebarModule,
        AuthModule.forRoot(),
        BrowserAnimationsModule,
        BrowserModule,
        BsDropdownModule.forRoot(),
        CarouselModule.forRoot(),
        ChartsModule,
        CollapseModule.forRoot(),
        FormsModule,
        PerfectScrollbarModule,
        ReactiveFormsModule,
        TabsModule.forRoot(),
        NgbModule,
        FuseSharedModule,
        FuseProgressBarModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,
        PowerBIEmbedModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatStepperModule,
        FuseSharedModule,
        MatToolbarModule,
        
    ],
    entryComponents: [
      InvitationDialogComponent
    ]
})
export class AppModule { }
